import { Preferences } from './WebPreferences';

const UNLOCKED_KEY = 'unlockedAnimals';

const UNLOCKABLE_ANIMALS = ['tiger2', 'cow', 'pig', 'panda', 'horse', 'puppy'];

let cachedUnlocked = null;

export async function getUnlockedAnimals() {
  if (cachedUnlocked !== null) return cachedUnlocked;
  const { value } = await Preferences.get({ key: UNLOCKED_KEY });
  cachedUnlocked = value ? JSON.parse(value) : [];
  return cachedUnlocked;
}

export async function unlockAnimal(name) {
  const unlocked = await getUnlockedAnimals();
  if (unlocked.includes(name)) return false;
  unlocked.push(name);
  cachedUnlocked = unlocked;
  await Preferences.set({ key: UNLOCKED_KEY, value: JSON.stringify(unlocked) });
  return true;
}

export async function isAnimalUnlocked(name) {
  const unlocked = await getUnlockedAnimals();
  return unlocked.includes(name);
}

export { UNLOCKABLE_ANIMALS };
